module.exports = __webpack_public_path__ + "assets/img/traffic.2dd66348.svg";